import { Link } from 'react-router-dom'
import { Logo } from '../ui/Logo'

export function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="container-wide py-12">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8">
          {/* Brand */}
          <div className="flex items-center gap-8">
            <Link to="/" className="flex items-center gap-2 text-white">
              <Logo className="h-8 w-8" />
              <span className="font-semibold">Sum1 Solutions</span>
            </Link>
            <nav className="flex gap-6 text-sm">
              <Link to="/about" className="hover:text-white transition-colors">About</Link>
              <Link to="/contact" className="hover:text-white transition-colors">Contact</Link>
            </nav>
          </div>

          {/* Legal */}
          <div className="flex gap-6 text-sm">
            <a href="/privacy.html" className="hover:text-white transition-colors">Privacy</a>
            <a href="/terms.html" className="hover:text-white transition-colors">Terms</a>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-slate-800 text-center">
          <p className="text-sm text-slate-400">
            © {new Date().getFullYear()} Sum1 Solutions, LLC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}
